import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Spinner from '@components/spinner/Spinner';

import authBackground from '@assets/images/auth/auth_background_new.png';

type AuthLayoutVariant = 'auth' | 'center';

interface AuthLayoutProps {
  variant?: AuthLayoutVariant;
  backgroundImage?: string;
}

const AuthLayout = ({
  variant = 'auth',
  backgroundImage = authBackground
}: AuthLayoutProps) => {
  const isCenterLayout = variant === 'center';

  return (
    <main className="relative h-dvh w-full overflow-hidden">
      {/* Background */}
      <img
        src={backgroundImage}
        alt=""
        aria-hidden="true"
        className="
    absolute
    inset-0
    size-full
    object-cover
    object-[center_65%]

    [@media(max-height:800px)]:object-[center_75%]
    [@media(max-height:700px)]:object-[center_85%]
  "
      />

      {isCenterLayout ? (
        /* Center layout */
        <section className="relative z-10 flex size-full items-center justify-center p-4">
          <div className="w-full max-w-[900px]">
            <Suspense
              fallback={
                <div className="flex min-h-[300px] items-center justify-center">
                  <Spinner />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </section>
      ) : (
        /* Two-column authentication layout */
        <div className="relative z-10 flex size-full">
          {/* Empty left section */}
          <section className="hidden h-full w-[45%] lg:block" />

          {/* Right authentication */}
          <section
            className="
              flex
              size-full
              items-center
              justify-center
              p-4
              lg:w-[55%]
              lg:px-8
              lg:py-5
            "
          >
            <div
              className="
                w-full
                max-w-[574px]
                rounded-48
                bg-[#FAF9FF]

                p-8
                sm:px-12
                sm:py-9
                md:px-16
                md:py-10
                lg:px-[84px]
                lg:py-10

                [@media(max-height:600px)]:rounded-[36px]
                [@media(max-height:600px)]:px-8
                [@media(max-height:600px)]:py-4

                [@media(max-height:700px)]:px-10
                [@media(max-height:700px)]:py-5

                [@media(max-height:800px)]:px-12
                [@media(max-height:800px)]:py-7
              "
            >
              <Suspense
                fallback={
                  <div className="flex min-h-[300px] items-center justify-center">
                    <Spinner />
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </div>
          </section>
        </div>
      )}
    </main>
  );
};

export default AuthLayout;
